import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Play"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.25001 21C4.83579 21 4.50001 20.6642 4.50001 20.25V3.74999C4.49894 3.48098 4.64203 3.232 4.87501 3.09749C5.10706 2.96352 5.39296 2.96352 5.62501 3.09749L19.875 11.3475C20.11 11.4807 20.2552 11.7299 20.2552 12C20.2552 12.2701 20.11 12.5193 19.875 12.6525L5.62501 20.9025C5.5107 20.9673 5.38139 21.0009 5.25001 21ZM6.00001 5.04749V18.9525L18 12L6.00001 5.04749Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Play.vue"]]);
